import { render, staticRenderFns } from "./BlackListSelection.vue?vue&type=template&id=76cd2c06&"
import script from "./BlackListSelection.vue?vue&type=script&lang=js&"
export * from "./BlackListSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports